import { render, staticRenderFns } from "./bank_details.vue?vue&type=template&id=7b612bd9&scoped=true"
import script from "./bank_details.vue?vue&type=script&lang=js"
export * from "./bank_details.vue?vue&type=script&lang=js"
import style0 from "./bank_details.vue?vue&type=style&index=0&id=7b612bd9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b612bd9",
  null
  
)

export default component.exports